import { createBreakpoints } from '@chakra-ui/theme-tools';

export const breakpoints = createBreakpoints({
  xs: '14rem',
  sm: '30rem',
  md: '48rem',
  base: '48rem',
  lg: '62rem',
  xl: '80rem'
});
